var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['badge badge-pill', _vm.styles]},[_vm._v("\n  "+_vm._s(_vm.type)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }